import { ChangeEvent } from 'react';
import { useField } from 'formik';
import { makeStyles, TextareaAutosize } from '@material-ui/core';
import { Colors, ErrorMessage } from '../controls/helpers';

export default (props: { name: string, disabled?: boolean, onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void }) => {
    const [field] = useField(props);
    const classes = useStyles();
    return <> 
        <TextareaAutosize
            className={classes.textarea}
            {...field}
            {...props}
            onChange={field.onChange}
            minRows={!props.disabled ? 10 : 1}
        />
        {!props.disabled && <ErrorMessage name={field?.name} />} 
    </>
} 

const useStyles = makeStyles({
    textarea: {
        color: Colors.Black,
        border: `1px solid ${Colors.Grey}`,
        borderRadius: '0.75rem',
        width: '100%',
        resize: 'none',
        padding: 10,
        margin: '0.75rem 0 0',
        fontFamily: ['Sons', 'Helvetica', 'Arial', 'sans-serif'].join(',')
    }
}, { name: 'AdviserTextarea' });
